import { useEffect, useState } from "react";
import axios from "axios";
import logo from '../karuncup-dark-1.svg';
import SignupForm from "../components/SignupForm";
function SignUp() {
  const [registrationEnable, setRegistrationEnable] = useState(null); // null یعنی هنوز معلوم نیست

  useEffect(() => {
    const checkRegistrationEnable = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/site-settings/`);
             

        // بسته به ساختار بک‌اند ممکنه یکی از این‌ها درست باشه:
        const enabled =
          response.data?.is_registration_enabled ??
          response.data?.is_registration_enable ??
          response.data?.results?.[0]?.is_registration_enabled;

        setRegistrationEnable(Boolean(enabled));
      } catch (e) {
        // اگر خطا خورد، بهتره مشخص کنید چه شود:
        setRegistrationEnable(false);
        console.error(e);
      }
    };

    checkRegistrationEnable();
  }, []);

  if (registrationEnable === null) {
    return <div className="App"><header className="App-header">در حال بررسی...</header></div>;
  }
  if(!registrationEnable){
    return (
       <div className="App">
      <header className="App-header">
        <img src={logo} className="w-24 h-24" alt="logo" />
        <h1 className='animate-pulse'>فرآیند ثبت نام غیرفعال می باشد</h1>
         <button
            onClick={() => (window.location.href = "/")}
            className="px-6 py-2 neon-border bg-lime-500 text-black rounded-xl text-lg font-semibold hover:bg-lime-300 transition"
          >
            بازگشت
          </button>
          <div className='flex flex-row space-x-2 my-4'>
          <svg width="48" height="48" viewBox="0 0 538 793" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M110.919 89.6064V37.6064H141.919V89.6064H110.919Z" fill="white"/>
            <path d="M110.919 282.606V165.606H141.919V282.606H110.919Z" fill="white"/>
            <path d="M65.9194 326.606V302.606H194.919V326.606H65.9194Z" fill="white"/>
            <path d="M207.919 335.606H43.9194V368.606H207.919V335.606Z" fill="white"/>
            <path d="M233.919 377.606H23.9194V420.606H233.919V377.606Z" fill="white"/>
            <path d="M2.91943 431.606H247.919V455.606H23.9194V581.606H2.91943V431.606Z" fill="white"/>
            <path d="M170.92 468.606C380.92 422.606 378.153 210.722 130.92 20.6064C118.882 2.99828 123.796 -1.88144 158.919 0.606367C566.919 20.6064 734.919 708.606 202.92 792.606C-63.0804 782.606 -61.0806 494.606 170.92 468.606Z" fill="white"/>
            <path d="M106.919 134.606L49.9194 152.606L145.919 97.6064V121.606L206.919 114.606L137.919 152.606H114.919L106.919 134.606Z" fill="white"/>
          </svg>
        </div>
        
      </header>
    </div>
    )
  }
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="w-24 h-24" alt="logo" />
        <SignupForm />
        
        <div className='flex flex-row space-x-2 my-4'>
          <svg width="48" height="48" viewBox="0 0 538 793" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M110.919 89.6064V37.6064H141.919V89.6064H110.919Z" fill="white"/>
            <path d="M110.919 282.606V165.606H141.919V282.606H110.919Z" fill="white"/>
            <path d="M65.9194 326.606V302.606H194.919V326.606H65.9194Z" fill="white"/>
            <path d="M207.919 335.606H43.9194V368.606H207.919V335.606Z" fill="white"/>
            <path d="M233.919 377.606H23.9194V420.606H233.919V377.606Z" fill="white"/>
            <path d="M2.91943 431.606H247.919V455.606H23.9194V581.606H2.91943V431.606Z" fill="white"/>
            <path d="M170.92 468.606C380.92 422.606 378.153 210.722 130.92 20.6064C118.882 2.99828 123.796 -1.88144 158.919 0.606367C566.919 20.6064 734.919 708.606 202.92 792.606C-63.0804 782.606 -61.0806 494.606 170.92 468.606Z" fill="white"/>
            <path d="M106.919 134.606L49.9194 152.606L145.919 97.6064V121.606L206.919 114.606L137.919 152.606H114.919L106.919 134.606Z" fill="white"/>
          </svg>
        </div>
        
      </header>
    </div>
  );
}

export default SignUp;
